import { NumberInput as t } from "@ark-ui/react/number-input";
import e, { forwardRef as E } from "react";
import { cx as N, css as I } from "@huspy/styled-system/css";
import { splitCssProps as b } from "@huspy/styled-system/jsx";
import { numberInput as o } from "@huspy/styled-system/recipes";
import { Minus as P, Plus as d } from "lucide-react";
import { Flex as C } from "../box/index.mjs";
import { IconButton as s } from "../icon-button/icon-button.mjs";
const g = E((n, a) => {
  const [l, c] = o.splitVariantProps(n), [p, i] = b(c), { children: m, className: u, ...f } = i, r = o(l);
  return /* @__PURE__ */ e.createElement(
    t.Root,
    {
      ref: a,
      className: N(r.root, I(p), u),
      ...f
    },
    m && /* @__PURE__ */ e.createElement(t.Label, { className: r.label }, m),
    /* @__PURE__ */ e.createElement(C, { className: r.flexContainer }, /* @__PURE__ */ e.createElement(t.DecrementTrigger, { asChild: !0 }, /* @__PURE__ */ e.createElement(s, { size: "sm" }, /* @__PURE__ */ e.createElement(P, null))), /* @__PURE__ */ e.createElement(t.Control, { className: r.control }, /* @__PURE__ */ e.createElement(t.Input, { className: r.input })), /* @__PURE__ */ e.createElement(t.IncrementTrigger, { asChild: !0 }, /* @__PURE__ */ e.createElement(s, { size: "sm" }, /* @__PURE__ */ e.createElement(d, null))))
  );
});
g.displayName = "NumberInput";
export {
  g as NumberInput
};
